export const AI_TOOLS = [{
  id: 'remove',
  title: 'ai_removal',
  description: 'intelligent_elimination_of_debris',
  icon: 'magicEliminationBold',
  badgeText: 'Hot',
  tipIcons: ['pictureV2Bold'],
  route: '/--roboneo/ai-eraser',
}, {
  id: 'change_to_hd',
  title: 'image_quality_repair',
  description: 'improve_clarity_and_detail',
  icon: 'hdRectangleBold',
  tipIcons: ['pictureV2Bold', 'videoV4Bold'],
  route: '/--roboneo/ai-enhance',
}, {
  id: 'remove_aimark',
  title: 'ai_watermark_removal',
  description: 'naturally_removes_watermarks_and_debris',
  icon: 'eraserV2Bold',
  badgeText: 'Hot',
  tipIcons: ['pictureV2Bold', 'videoV4Bold'],
  route: '/--roboneo/ai-watermark',
},
{
  id: 'cut_out',
  title: 'ai_cutout',
  description: 'remove_background_quickly',
  icon: 'cutOutBold',
  tipIcons: ['pictureV2Bold'],
  route: '/--roboneo/ai-cutout',
},
];
